import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from "@mui/material";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

// Papelera única de la app. Va negra en reposo y roja al pasar el mouse: con el
// rojo fijo cada fila de una lista gritaba "peligro", y así el aviso aparece
// cuando el usuario efectivamente apunta a la acción.
//
// El <span> envuelve al botón porque un Tooltip sobre un botón deshabilitado no
// recibe eventos y no llega a mostrarse. Y el color del estado deshabilitado se
// repite a mano porque el `color` del sx le gana al que pone MUI.
const TrashIconButton = ({
    title = 'Eliminar',
    size = 'small',
    edge,
    disabled = false,
    onClick,
    children,
}) => (
    <Tooltip title={title}>
        <span>
            <IconButton
                size={size}
                edge={edge}
                disabled={disabled}
                onClick={onClick}
                sx={{
                    color: 'text.primary',
                    '&:hover': { color: 'error.main' },
                    '&.Mui-disabled': { color: 'action.disabled' },
                }}
            >
                {children || <DeleteOutlineOutlinedIcon fontSize={size === 'small' ? 'small' : 'medium'} />}
            </IconButton>
        </span>
    </Tooltip>
);

TrashIconButton.propTypes = {
    title: PropTypes.node,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    edge: PropTypes.oneOf(['start', 'end', false]),
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    // Para reemplazar el ícono mientras la acción está en curso (un spinner).
    children: PropTypes.node,
};

export default TrashIconButton;
